import { Component, EventEmitter, Inject, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as moment from 'moment';
import { DatepickerCustomHeaderComponent } from '../datepicker-custom-header/datepicker-custom-header.component';
import * as _ from 'lodash';
import { MatCalendar } from '@angular/material/datepicker';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { LocaleService } from 'src/app/services/locale.service';

export const CUSTOM_DATE_FORMAT = {
  display: {
    monthYearLabel: {year: 'numeric', month: 'long'},
  }
};

@Component({
  selector: 'app-datepicker-dialog',
  templateUrl: './datepicker-dialog.component.html',
  styleUrls: ['./datepicker-dialog.component.css'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'ES-es' },
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMAT },
  ],
  standalone: false
})
export class DatepickerDialogComponent implements OnInit {
  @Output() onSubmit = new EventEmitter<moment.Moment>();

  formGroup!: UntypedFormGroup;
  calendarDate!: Date | null;

  @ViewChild(MatCalendar) calendar!: MatCalendar<Date>;
  customHeader = DatepickerCustomHeaderComponent;

  constructor(
    private _adapter: DateAdapter<any>,
    public dialogRef: MatDialogRef<DatepickerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { label: string, maxDate?: Date },
    private fb: UntypedFormBuilder,
    @Inject(MAT_DATE_LOCALE) private _locale: string,
    private localeService: LocaleService,
  ) {
    this._locale = this.localeService.getLocale();
    this._adapter.setLocale(this._locale);

    this.formGroup = this.fb.group({
      date: moment()
    });
  }

  ngOnInit(): void {
    this.calendarDate = new Date();

    this.date.valueChanges.subscribe((value: moment.Moment) => {
      if(value && !_.isString(value)) {
        this.calendarDate = value.toDate();
        this.calendar.activeDate = this.calendarDate;
      }
    })
  }

  selectedDate(date: string): void {
    this.date.setValue(moment(date), {emitEvent: false});
  }

  get date(): UntypedFormControl { return this.formGroup.get('date') as UntypedFormControl }
}
